import type { FC } from 'react';
import { classes } from './Loader.st.css';
import { Loader as BaseLoader } from 'wix-style-react';

export const Loader: FC = ({ size = 'small' }) => {
  return (
    <div className={classes.wrapper}>
      <BaseLoader size={size} />
    </div>
  );
};
